export enum PermissionEnum {
  HasWriteAccess = 1, // Can Create/Edit/Delete records in the allowed APIs
  CanViewBankAccounts = 2,
  CanEditBankAccounts = 3,
  CanViewPayments = 4,
  CanCreatePayments = 5,
  RiskOrFinanceTeam = 7,
  CheckFullKybAdministrator = 8,
  CanManageFeatureFlags = 12, // Can create/edit/remove feature flags
  CanReverseCommission = 16, // Can reverse commissions
  AllowTransfersFBOToTongoSVB = 17, // Can create/view manual FBO -> Tongo SVB Astra transfers
  CanResetSmsValidationCache = 18, // Can reset SMS verification cache/attempts
  CanSendAgentPayments = 19, // Can send direct ACH payments to agents (reconciliations/refunds)
  CanRevealBankAccounts = 20, // Can unmask partner bank account and routing numbers
  SuperAdmin = 1000, // Full access
}

export const permissionNames = {
  [PermissionEnum.HasWriteAccess]: 'Has Write Access',
  [PermissionEnum.CanViewBankAccounts]: 'Can View Bank Accounts',
  [PermissionEnum.CanEditBankAccounts]: 'Can Edit Bank Accounts',
  [PermissionEnum.CanViewPayments]: 'Can View Payments',
  [PermissionEnum.CanCreatePayments]: 'Can Create Payments',
  [PermissionEnum.RiskOrFinanceTeam]: 'Risk Or Finance Team',
  [PermissionEnum.CheckFullKybAdministrator]: 'Check Full Kyb Administrator',
  [PermissionEnum.CanManageFeatureFlags]: 'Can Manage Feature Flags',
  [PermissionEnum.CanReverseCommission]: 'Can Reverse Commission',
  [PermissionEnum.AllowTransfersFBOToTongoSVB]:
    'Allow Transfers FBO To Tongo SVB',
  [PermissionEnum.CanResetSmsValidationCache]: 'Can Reset SMS Validation Cache',
  [PermissionEnum.CanSendAgentPayments]: 'Can Send Agent Payments',
  [PermissionEnum.CanRevealBankAccounts]: 'Can Reveal Bank Accounts',
  [PermissionEnum.SuperAdmin]: 'Super Admin',
};
